// src/screens/Login/Login.js

import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebaseconfig";
import "./Login.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    try {
      // 1. Tenta logar
      await signInWithEmailAndPassword(auth, email, password);

      // 2. Se não deu erro acima, manda direto pra conta.
      // O AuthContext vai cuidar de carregar os dados enquanto a navegação acontece.
      navigate("/conta");
    } catch (err) {
      console.error("Erro login:", err);
      if (
        err.code === "auth/invalid-credential" ||
        err.code === "auth/user-not-found" ||
        err.code === "auth/wrong-password"
      ) {
        setError("Email ou senha inválidos.");
      } else {
        setError("Ocorreu um erro ao tentar fazer login.");
      }
    } finally {
      // Nota: Se o navigate acontecer, o componente vai desmontar e isso aqui nem roda, o que é ok.
      // Se der erro, ele roda e libera o botão.
      setIsLoading(false);
    }
  };

  return (
    <div className="agroauth-login-container">
      <div className="agroauth-login-card">
        <div className="agroauth-login-header">
          <h2 className="agroauth-login-title">Acesse sua conta</h2>
          <p className="agroauth-login-subtitle">
            Entre com seus dados para continuar
          </p>
        </div>

        <form onSubmit={handleLogin} className="agroauth-login-form">
          <div className="agroauth-input-group">
            <label htmlFor="agroauth-email" className="agroauth-input-label">
              Email
            </label>
            <input
              id="agroauth-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu@email.com"
              className="agroauth-input-field"
              required
            />
          </div>

          <div className="agroauth-input-group">
            <label htmlFor="agroauth-password" className="agroauth-input-label">
              Senha
            </label>
            <input
              id="agroauth-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Digite sua senha"
              className="agroauth-input-field"
              required
            />
          </div>

          {error && <div className="agroauth-error-message">{error}</div>}

          <button
            type="submit"
            className="agroauth-login-button"
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="agroauth-spinner"></span>
            ) : (
              "Entrar na plataforma"
            )}
          </button>
        </form>

        <div className="agroauth-login-footer">
          <Link to="/forgot-password" className="agroauth-forgot-link">
            Esqueceu sua senha?
          </Link>
          <p className="agroauth-register-text">
            Não possui conta?{" "}
            <Link to="/register" className="agroauth-register-link">
              Crie uma agora
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
